export default __webpack_public_path__ + "static/media/D7R.be4b6ee8.pdf";